<template>
  <button
    v-if="!href"
    :type="type"
    :form="form"
    :disabled="disabled"
    class="def-button-secondary"
    :class="{ 'def-button-secondary_big': big }"
  >
    <slot />
  </button>

  <a
    v-else
    :href="href"
    :rel="rel"
    class="def-button-secondary"
    :class="{ 'def-button-secondary_big': big }"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'DefButtonSecondary',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    href: {
      type: String,
    },
    form: String,
    rel: String,
    disabled: Boolean,
    big: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.def-button-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  background-color: transparent;
  border: 1px solid var(--background-black);
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  transition: 0.2s linear background-color;
  padding: 0 18px;
  cursor: pointer;
  &:hover {
    background-color: rgba(61, 61, 81, 0.05);
  }
  &:disabled {
    border-color: #e0e0e0;
    color: #b0b0b0;
    cursor: not-allowed;
  }
  &_big {
    @include point-md {
      height: 52px;
    }
  }
}
</style>
